import {AbstractEvent} from "@/modules/base/events";
import {Terrace} from "@/modules/stadium/entity";

export class AfterEntranceFeeChangeEvent extends AbstractEvent {
  constructor(
    public terrace: Terrace,
  ) {
    super();
  }
}